/**
 * useClipboard
 * 
 * Hook para copiar texto para a área de transferência com feedback.
 */
import { useCallback } from 'react';
import { notify } from '../utils/toast';

export const useClipboard = () => {
    const copyToClipboard = useCallback(async (text: string, label: string = 'Texto') => {
        try {
            await navigator.clipboard.writeText(text);
            notify.success(`${label} copiado!`);
            return true;
        } catch (error) {
            console.error('Copy failed', error);
            notify.error('Erro ao copiar');
            return false;
        }
    }, []);

    return { copyToClipboard };
};
